@import '~style-sheet-helpers/core.less';
@import (reference) '../../../products/product-details/style.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.input-wrapper {
  Input {
    .input-border-base-style();
  }
}

.modal {
  width: 500px;
}

.modal-body {
  padding-left: 20px;
  background-color: @product-page--modal--background-color;
  max-height: 560px;
}

.warning {
  margin: 20px;
  height: 50px;
}

.edit-button {
  margin-right: 15px;
}

.preset-group {
  width: 850px;
  background-color: @products-page--preset-group--background-color;
}

.leftside-label {
  padding: 5px 15px 5px 0;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.header-description {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  line-height: 1.3;
}

.section-description {
  padding-bottom: 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  line-height: 1.3;
}

.section-label {
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 500;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.paired-options {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}

.shipping-options {
  display: grid;
  grid-template-columns: 33% 33% 33%;
}

.customs-options {
  padding: 5px 10px 10px;

  > * {
    padding: 10px 10px 0;
    font-weight: 500;
  }
}

.options-dropdown-wrapper {
  padding: 5px 10px 5px 0;
  font-size: 14px;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  select {
    padding: 5px;
  }
}

.weight-input {
  width: 75px;
  font-size: 14px;
  height: 32px;
  .input-border-base-style();
}

.size-input {
  width: 60px;
  font-size: 14px;
  height: 32px;
  .input-border-base-style();
}

.no-customs-options {
  padding-bottom: 15px;
  font-weight: 400;
}

.origin-country {
  width: 250px;
  select {
    padding: 5px;
  }
}

.paired-input {
  width: 250px;
}

.dropdown-picker {
  padding: 7px 10px 8px;
  font-size: 14px;
  line-height: 1.1;
  font-weight: 400;
}

.currency-input {
  height: 36px;
  .input-border-base-style();
}

.footer-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  button {
    margin-left: 15px;
  }
}
